import * as THBText from 'thai-baht-text';
var Number2textThService = (function () {
    function Number2textThService() {
    }
    Number2textThService.prototype.currencyFormat_Baht = function (number) {
        if (!number) {
            return 'ศูนย์บาทถ้วน';
        }
        return THBText(number);
    };
    return Number2textThService;
}());
export { Number2textThService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/number2text-th.service.ts.pre-build-optimizer.js